import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/add-image.svg'


const _hoisted_1 = { class: "p-field w-full mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "p-error"
}
const _hoisted_3 = { class: "grid gap-2 grid-cols-2 mb-3" }
const _hoisted_4 = { class: "p-field w-full" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-field w-full" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "flex items-center justify-between mb-3" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-sm" }, "Keterangan Bukti Foto (Max.5)", -1)
const _hoisted_10 = { class: "grid lg:grid-cols-5 grid-cols-2 md:grid-cols-3 gap-3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "grid md:grid-cols-3 grid-cols-2 lg:grid-cols-5 gap-3"
}
const _hoisted_13 = { class: "w-full mt-6 absolute bottom-0 left-0 right-0 px-6 py-6 bg-white" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Serah Terima")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Batalkan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("form", {
      id: "form-add-receive",
      class: "mb-14",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("label", {
          for: "name",
          class: {'p-error':_ctx.v$.name.$invalid && _ctx.submitted, 'text-body2': true}
        }, "Nama Penerima", 2),
        _createVNode(_component_InputText, {
          id: "name",
          class: "input-primary w-full mt-1 rounded-lg",
          name: "name",
          modelValue: _ctx.v$.name.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.name.$model = $event)),
          type: "text"
        }, null, 8, ["modelValue"]),
        _createVNode("div", null, [
          ((_ctx.v$.name.$invalid && _ctx.submitted) || _ctx.v$.name.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_2, _toDisplayString(_ctx.v$.name.required.$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("label", {
            for: "numberPhone",
            class: {'p-error':_ctx.v$.numberPhone.$invalid && _ctx.submitted, 'text-body2': true}
          }, "Nomor Telepon", 2),
          _createVNode(_component_InputText, {
            id: "numberPhone",
            class: "input-primary w-full mt-1 rounded-lg",
            name: "numberPhone",
            modelValue: _ctx.v$.numberPhone.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.numberPhone.$model = $event)),
            type: "tel"
          }, null, 8, ["modelValue"]),
          _createVNode("div", null, [
            ((_ctx.v$.numberPhone.$invalid && _ctx.submitted) || _ctx.v$.numberPhone.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_5, _toDisplayString((_ctx.v$.numberPhone.required.$invalid) ? _ctx.v$.numberPhone.required.$message : _ctx.v$.numberPhone.numeric.$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("label", {
            for: "noKtp",
            class: {'p-error':_ctx.v$.noKtp.$invalid && _ctx.submitted, 'text-body2': true}
          }, "Nomor KTP", 2),
          _createVNode(_component_InputText, {
            id: "noKtp",
            class: "input-primary w-full mt-1 rounded-lg",
            name: "noKtp",
            maxlength: "16",
            modelValue: _ctx.v$.noKtp.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.noKtp.$model = $event)),
            type: "tel"
          }, null, 8, ["modelValue"]),
          _createVNode("div", null, [
            ((_ctx.v$.noKtp.$invalid && _ctx.submitted) || _ctx.v$.noKtp.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_7, _toDisplayString((_ctx.v$.noKtp.required.$invalid) ? _ctx.v$.noKtp.required.$message : (_ctx.v$.noKtp.numeric.$invalid) ? _ctx.v$.noKtp.numeric.$message : _ctx.v$.noKtp.maxLength.$message), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          (_ctx.checkSrcListImage() < 5)
            ? (_openBlock(), _createBlock("p", {
                key: 0,
                class: "font-semibold color-blue-grey lg:text-base md:text-base text-sm underline",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetImage()))
              }, " Reset "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.$store.state.device.isMobile)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "list-photo",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCamera()))
            }, [
              _createVNode("div", _hoisted_10, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listImage, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: 'image-'+ index,
                    class: "relative mb-3"
                  }, [
                    (item.src === null)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "w-full",
                          src: _imports_0,
                          alt: item.name
                        }, null, 8, ["alt"]))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          class: "w-full object-cover md:h-28 lg:h-20 h-36 rounded-lg",
                          src: item.src,
                          alt: item.name
                        }, null, 8, ["src", "alt"]))
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createBlock("div", _mergeProps({ key: 1 }, _ctx.getRootProps()), [
              _createVNode("input", _ctx.getInputProps(), null, 16),
              (_ctx.isDragActive)
                ? (_openBlock(), _createBlock("p", _hoisted_11, "Drop the files here ..."))
                : (_openBlock(), _createBlock("div", _hoisted_12, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listImage, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: 'image-'+ index,
                        class: "relative mb-3"
                      }, [
                        (item.src === null)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              class: "w-full",
                              src: _imports_0,
                              alt: item.name
                            }, null, 8, ["alt"]))
                          : (_openBlock(), _createBlock("img", {
                              key: 1,
                              class: "w-full object-cover md:h-28 lg:h-20 h-36 rounded-lg",
                              src: item.src,
                              alt: item.name
                            }, null, 8, ["src", "alt"]))
                      ]))
                    }), 128))
                  ]))
            ], 16))
      ])
    ], 32),
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_Button, {
        class: "btn-primary text-black mr-3 px-10 py-1",
        type: "submit",
        form: "form-add-receive"
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn-secondary text-black px-10 py-1",
        type: "button",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hideForm()))
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      })
    ])
  ]))
}